import EnumService from '../EnumService'

export default class SexoEnumService extends EnumService{

    constructor(){
        super('enumSexo');
    }
  
  }